import { useMemo } from "react"
import { Modal, Button } from "react-bootstrap"

/**
 * content: any element or string to display
 * title: (optional) default: Confirmation
 * show: visibility state of the modal
 * toggleModal: function to call when closing the modal
 */
interface SimpleCrystalBallModalProps {
  content: React.ReactNode
  title?: React.ReactNode
  show: boolean
  toggleModal: any
}

SimpleCrystalBallModal.defaultProps = {
  title: 'Confirmation'
}
/**
 * Feel free to add optional params to this as desired
 * @param props 
 */
export default function SimpleCrystalBallModal(props: SimpleCrystalBallModalProps) {
 

  const modal = useMemo(() => {
    return (
      <Modal show={props.show} onHide={props.toggleModal} centered={true} backdrop={"static"} style={{ fontSize: "16px" }}>
        <Modal.Header closeButton>
          <Modal.Title>{props.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{props.content}</Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={props.toggleModal}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>
      )
  }, [props])

  return modal

}